export const getYogurtPackage = newProduct => {
  const newYogurtPackage = {
    UPC: newProduct.UPC,
    VitaminD: newProduct.VitaminD,
    Sugar: newProduct.Sugar,
    SugarCertification: newProduct.SugarCertification,
    SweetenerCertification: newProduct.SweetenerCertification,
    FatLevel: newProduct.FatLevel,
    Flavor: newProduct.Flavor,
    OtherFlavor: newProduct.OtherFlavor,
    Size: newProduct.Size,
    MultiPackageType: newProduct.MultiPackageType,
    MultiPackageCount: newProduct.MultiPackageType
      ? newProduct.MultiPackageCount
      : null,
  }
  return newYogurtPackage
}

export const updateYogurtPackage = newProduct => {
  const newYogurtPackage = {
    UPC: newProduct.UPC,
    VitaminD: newProduct.VitaminD,
    Sugar: newProduct.Sugar,
    SugarCertification: newProduct.SugarCertification,
    SweetenerCertification: newProduct.SweetenerCertification,
    FatLevel: newProduct.FatLevel,
    Flavor: newProduct.Flavor,
    OtherFlavor: newProduct.OtherFlavor,
    Size: newProduct.Size,
    MultiPackageType: newProduct.MultiPackageType,
    MultiPackageCount: newProduct.MultiPackageType
      ? newProduct.MultiPackageCount
      : null,
  }
  return newYogurtPackage
}
